const HTTP_PROTOCOLS = new Set(['http:', 'https:'])

export const toSafeHttpUrl = (value: string): string | null => {
  const candidate = value.startsWith('www.') ? `https://${value}` : value

  try {
    const url = new URL(candidate)

    if (!HTTP_PROTOCOLS.has(url.protocol) || url.username || url.password) {
      return null
    }

    return url.href
  } catch {
    return null
  }
}
